export default __webpack_public_path__ + "static/media/Leads-orange.e5781558.svg";